module.exports = "<div\n    class=\"m-tutorial-launcher\" (click)=\"GlobalStaticSrv.callTutorial(2, 1)\"\n>\n    ?\n</div>\n"